<template>
<div>
    <Breadcrumbs main="Admin" submain="System" title="Coin Feature" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Feature</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="coin_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(feature)="row">
                                        <div v-if="row.item.feature" style="min-width: 150px;">
                                            <h7>{{ row.item.feature }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(slug)="row">
                                        <div v-if="row.item.slug" style="min-width: 150px;">
                                            <h7>{{ row.item.slug }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(coin_cost)="row">
                                        <div v-if="row.item.coin_cost" style="max-width: 150px;">
                                            <h7>{{ row.item.coin_cost }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCoin(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editCoin(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Coin Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Coin" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Feature</label>
                        <input class="form-control" type="text" placeholder="Enter coin feature" v-model="coin.feature">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Slug</label>
                        <input class="form-control" type="text" placeholder="Enter slug" v-model="coin.slug">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Coin Cost</label>
                        <input class="form-control" type="number" placeholder="Enter coin cost" v-model="coin.coin_cost">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Coin Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Coin" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Feature</label>
                        <input class="form-control" type="text" placeholder="Enter coin feature" v-model="edit_coin.feature">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Slug</label>
                        <input class="form-control" type="text" placeholder="Enter slug" v-model="edit_coin.slug">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Coin Cost</label>
                        <input class="form-control" type="number" placeholder="Enter coin cost" v-model="edit_coin.coin_cost">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Coin Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this feature?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() { 
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'feature',
                    label: 'Feature',
                    sortable: true
                },
                {
                    key: 'slug',
                    label: 'Slug',
                    sortable: true
                },
                {
                    key: 'coin_cost',
                    label: 'Coin Cost',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            coin: {
                feature: "",
                slug: "",
                coin_cost: null
            },
            edit_coin: {
                id: null,
                feature: "",
                slug: "",
                coin_cost: null
            },
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            coin_list: state => state.coin.coin,
            loading: state => state.coin.coinLoading,
            error: state => state.coin.coinError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
            .filter(f => f.sortable)
            .map(f => {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },

    mounted() {
        this.$store.dispatch("upazila/fetchUpazila")
        this.$store.dispatch("coin/fetchCoin").then(() => {
            this.items = this.coin_list
            this.totalRows = this.coin_list.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.coin.feature = ""
            this.coin.slug = ""
            this.coin.coin_cost = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("coin/addCoin", {
                coin: this.coin
            }).then(response => {
                if (response.code == 201) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                   this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editCoin(detail) {
            this.edit_coin.id = detail.id ? detail.id : null
            this.edit_coin.feature = detail.feature ? detail.feature : null
            this.edit_coin.slug = detail.slug ? detail.slug : null
            this.edit_coin.coin_cost = detail.coin_cost ? detail.coin_cost : 0
        },

        resetEditModal() {
            this.edit_coin.feature = null
            this.edit_coin.coin_cost = null
            this.edit_coin.slug = null
            this.edit_coin.id = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("coin/updateCoin", {
                id: this.edit_coin.id,
                coin: this.edit_coin
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteCoin(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("coin/deleteCoin", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 204) { 
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
